/**
 * Logout Controller file
 * @class
 */

class LogoutController {
    /* @ngInject */
    constructor (NewTokenService, NewBackendService, Dispatcher, LoginService, $timeout, $rootScope) {
        var that = this;
        const init = () => {
            NewTokenService.clearAllStorages();
            NewTokenService.doReset();
            NewBackendService.cleanWalletId();
            Dispatcher.dispatch({
                actionType: 'GLOBAL_CLEAN'
            });

            $rootScope.$broadcast('USER_LOGGED_OUT');
            /*LoginService.logout();
            $timeout(() => {
                window.location.href= '#';
            }, 500);*/
        };

        that.$onInit = init;
    }
}

export default LogoutController;



/** WEBPACK FOOTER **
 ** ./client/app/components/logout/logout.controller.js
 **/